import { ErrorInfo } from 'react';
import { QueryErrorState } from '@rideiq/shared/components/QueryErrorState';

export interface PageErrorFallbackProps {
  error: Error;
  info: ErrorInfo;
  clearError: () => void;
}

export const PageErrorFallback = ({ clearError }: PageErrorFallbackProps) => (
  <QueryErrorState message="Something went wrong. Please try again." tableHeightOffset={0} onRetry={clearError} />
);
